/**
 * Format a frontmatter date for display.
 *
 * Dates arrive as bare `YYYY-MM-DD`. `new Date('2026-08-04')` parses that as
 * UTC midnight, and `toLocaleDateString` then renders it in the viewer's zone —
 * which puts every post a day early for anyone west of Greenwich. Splitting the
 * parts and building a local date keeps the day the author wrote.
 */
export function formatDocDate(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number)
  if (!y || !m || !d) return iso
  return new Date(y, m - 1, d).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}
